const match = {
  // Constants for matching text
  matchBottom: "MATCHING BOTTOM",
  matchTop: "MATCHING TOP",
  matchingTopBottomData: [],
  // Flag to track initialization
  initialized: false,

  init: function () {
    // Prevent multiple initializations
    if (match.initialized) {
      return;
    }

    // Initialize matching data from window.matchTopBottom if available
    if (window.matchTopBottom && window.matchTopBottom.length > 0) {
      window.matchTopBottom.forEach(function (item) {
        const data = item.split("|");
        const matchTopBottom = [
          {
            key: data[0],
            replaceKeyTo: data[1],
            type: "Top",
            replaceType: "Bottom",
            buttonTitle: match.matchBottom,
            buttonTitleBottom: match.matchBottom,
            inlucdeSaleProducts: data[2] ? data[2] : false,
          },
          {
            key: data[1],
            replaceKeyTo: data[0],
            type: "Bottom",
            replaceType: "Top",
            buttonTitle: match.matchTop,
            buttonTitleBottom: match.matchTop,
            inlucdeSaleProducts: data[2] ? data[2] : false,
          },
        ];

        match.matchingTopBottomData.push(...matchTopBottom);
      });
    }

    // Initialize matching products with a slight delay to ensure DOM is ready
    // and avoid conflicts with other initializations
    setTimeout(function () {
      match.initMatchingProducts();
      match.initialized = true;
    }, 50);
  },

  getMatchingCustomRushGuard: function () {
    match.getData(function (product) {
      const handle = product.handle;
      const text = "View Matching";

      // Add specific product matches
      if (handle.indexOf("bottom-etruria-cambusa") > -1) {
        const url =
          "https://shop.baliswim.com/products/bsws-r07-rash-guard-etruria-cambusa?_pos=48&_sid=fac9393b3&_ss=r";
        $("#button_after-add-to-bag-1").removeClass("full-width-button");
        $(".__matching-prod__bottom").append(
          `<a class="btn" href="${url}">${text} Top</a>`,
        );
        $(".__button-related-prod").addClass("__has-matching-content");
        $(".__match-top-bottom").append(`<a href="${url}">${text} Top</a>`);
      }

      if (handle.indexOf("guard-etruria-cambusa") > -1) {
        const url =
          "https://shop.baliswim.com/products/bsws-b29-bottom-etruria-cambusa";
        $("#button_after-add-to-bag-1").removeClass("full-width-button");
        $(".__matching-prod__bottom").append(
          `<a class="btn" href="${url}">${text} Bottom</a>`,
        );
        $(".__button-related-prod").addClass("__has-matching-content");
        $(".__match-top-bottom").append(`<a href="${url}">${text} Bottom</a>`);
      }
    });
  },

  getData: function (cb) {
    const getProductHandle =
      $(".product-section").attr("data-product-handle") || window.__productSlug;

    if (getProductHandle) {
      const apiUrl = `/products/${getProductHandle}.json`;

      $.getJSON(apiUrl)
        .done(function (res) {
          const product = res.product;
          if (cb) cb(product);
        })
        .fail(function (error) {
          console.error("Error fetching product data:", error);
        });
    }
  },

  initMatchingProducts: function () {
    match.getData(function (product) {
      if (!product) return;

      // Get product title and tags for matching
      const productTitle = product.title;

      // Ensure tags is an array
      let productTags = [];
      if (product.tags) {
        // Handle tags whether it's a string, array, or comma-separated string
        if (Array.isArray(product.tags)) {
          productTags = product.tags;
        } else if (typeof product.tags === "string") {
          // Split by comma if it's a comma-separated string
          productTags = product.tags.split(",").map((tag) => tag.trim());
        }
      }

      // Check if product has 'unmatch' tag
      const hasUnmatchTag =
        productTags.filter((tag) => tag.toLowerCase() === "unmatch").length > 0;
      if (hasUnmatchTag) {
        console.log("Product has unmatch tag, skipping matching");
        return;
      }

      // Split product title to get the product code
      const titleParts = productTitle.split(" ");
      const productCode = titleParts[0];

      // Define related product patterns
      const relatedLinkProduct = [
        {
          key: "BS-T",
          replaceKeyTo: "BS-B",
          type: "Top",
          replaceType: "Bottom",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSWS-T",
          replaceKeyTo: "BSWS-B",
          type: "Top",
          replaceType: "Bottom",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSWS-B",
          replaceKeyTo: "BSWS-T",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BSMB-T",
          replaceKeyTo: "BSMB-B",
          type: "Top",
          replaceType: "Bottom",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSMB-B",
          replaceKeyTo: "BSMB-T",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BSMA-B",
          replaceKeyTo: "BSMA-T",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BSMA-T",
          replaceKeyTo: "BSMA-B",
          type: "Top",
          replaceType: "Bottom",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSWA-T",
          replaceKeyTo: "BSWA-B",
          type: "Top",
          replaceType: "Bottom",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSWA-B",
          replaceKeyTo: "BSWA-T",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BS-B",
          replaceKeyTo: "BS-T",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BA-B",
          replaceKeyTo: "BA-T",
          type: "Leggings",
          replaceType: "Sport Bra",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BA-T",
          replaceKeyTo: "BA-B",
          type: "Sport Bra",
          replaceType: "Leggings",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BA-B",
          replaceKeyTo: "BA-T",
          type: "Shorts",
          replaceType: "Sport Bra",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BA-T",
          replaceKeyTo: "BA-B",
          type: "Sport Bra",
          replaceType: "Shorts",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSWL-B",
          replaceKeyTo: "BSWL-T",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BSWL-T",
          replaceKeyTo: "BSWL-B",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSGS-T",
          replaceKeyTo: "BSGS-B",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: "MATCHING BOTTOM",
          buttonTitleBottom: "MATCHING BOTTOM",
        },
        {
          key: "BSGS-B",
          replaceKeyTo: "BSGS-T",
          type: "Top",
          replaceType: "Bottom",
          buttonTitle: "MATCHING TOP",
          buttonTitleBottom: "MATCHING TOP",
        },
        {
          key: "BSWSP-T",
          replaceKeyTo: "BSWSP-B",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSWSP-B",
          replaceKeyTo: "BSWSP-T",
          type: "Top",
          replaceType: "Bottom",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BSWS-T",
          replaceKeyTo: "BSWS-B",
          type: "Bikini Bottom",
          replaceType: "Bikini Top",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSWS-B",
          replaceKeyTo: "BSWS-T",
          type: "Bikini Top",
          replaceType: "Bikini Bottom",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BSWR-T",
          replaceKeyTo: "BSWR-B",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSWR-B",
          replaceKeyTo: "BSWR-T",
          type: "Top",
          replaceType: "Bottom",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BSGS-RT",
          replaceKeyTo: "BSGS-RB",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSGS-RB",
          replaceKeyTo: "BSGS-RT",
          type: "Top",
          replaceType: "Bottom",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BSMR-T",
          replaceKeyTo: "BSMR-S",
          type: "Top",
          replaceType: "Bottom",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSMR-S",
          replaceKeyTo: "BSMR-T",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BSWA-GST01",
          replaceKeyTo: "BSWA-GSB01",
          type: "Top",
          replaceType: "Bottom",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSWA-GSB01",
          replaceKeyTo: "BSWA-GST01",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BSWA-GST02",
          replaceKeyTo: "BSWA-GSB02",
          type: "Top",
          replaceType: "Bottom",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSWA-GSB02",
          replaceKeyTo: "BSWA-GST02",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BSWA-GST03",
          replaceKeyTo: "BSWA-GSB03",
          type: "Top",
          replaceType: "Bottom",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSWA-GSB03",
          replaceKeyTo: "BSWA-GST03",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
        {
          key: "BSWRC-T01",
          replaceKeyTo: "BSWRC-B01",
          type: "Top",
          replaceType: "Bottom",
          buttonTitle: match.matchBottom,
          buttonTitleBottom: match.matchBottom,
        },
        {
          key: "BSWRC-B01",
          replaceKeyTo: "BSWRC-T01",
          type: "Bottom",
          replaceType: "Top",
          buttonTitle: match.matchTop,
          buttonTitleBottom: match.matchTop,
        },
      ];

      // Add any additional matching data
      if (
        match.matchingTopBottomData &&
        match.matchingTopBottomData.length > 0
      ) {
        relatedLinkProduct.push(...match.matchingTopBottomData);
      }

      // Find matching product pattern
      for (let i = 0; i < relatedLinkProduct.length; i++) {
        const findProd = relatedLinkProduct[i];

        if (productCode.indexOf(findProd.key) > -1) {
          const relatedProdCode = productCode.replace(
            findProd.key,
            findProd.replaceKeyTo,
          );
          match.getRelatedProduct(
            relatedProdCode,
            findProd.buttonTitle,
            findProd.buttonTitleBottom,
            findProd,
          );
        }
      }
    });
  },

  getRelatedProduct: function (
    searchCode,
    buttonTitle,
    buttonTitleBottom,
    detail,
  ) {
    const relatedProdMain = $(".__button-related-prod");
    const relatedProdBottom = $(".__matching-prod__bottom");

    if (!relatedProdMain.length) return;

    // First, let's get the current product's fabric and color
    // We'll use match-color.js data if available since it's more reliable
    let currentFabric = "";
    let currentColor = "";

    // Method 1: Try to get fabric and color from variant selectors
    const fabricSelector = $(
      'input[name="Fabric"]:checked, select[name="Fabric"] option:selected',
    );
    const colorSelector = $(
      'input[name="Color"]:checked, select[name="Color"] option:selected',
    );

    if (fabricSelector.length) {
      currentFabric = fabricSelector.val();
    }

    if (colorSelector.length) {
      currentColor = colorSelector.val();
    }

    // Method 2: Try to get from fieldset elements
    if (!currentFabric) {
      const fabricFieldset = $('fieldset[name="Fabric"]');
      if (fabricFieldset.length) {
        const checkedInput = fabricFieldset.find('input[type="radio"]:checked');
        if (checkedInput.length) {
          currentFabric = checkedInput.val();
        } else {
          // Try to find the active option in the custom container
          const activeOption = fabricFieldset.find(".bs__custom-option.active");
          if (activeOption.length) {
            currentFabric = activeOption.find("label").text().trim();
          }
        }
      }
    }

    if (!currentColor) {
      const colorFieldset = $('fieldset[name="Color"]');
      if (colorFieldset.length) {
        const checkedInput = colorFieldset.find('input[type="radio"]:checked');
        if (checkedInput.length) {
          currentColor = checkedInput.val();
        } else {
          // Try to find the active option in the custom container
          const activeOption = colorFieldset.find(".bs__custom-option.active");
          if (activeOption.length) {
            // Extract color name from the label or the div with class bs__color-label-name
            const colorName =
              activeOption.find(".bs__color-label-name").text().trim() ||
              activeOption.find("label").text().trim();
            if (colorName) {
              currentColor = colorName;
            }
          }
        }
      }
    }

    // If we couldn't get from selectors, try the product JSON
    if (!currentFabric || !currentColor) {
      const productJSON = $("[data-product-json]").length
        ? JSON.parse($("[data-product-json]").html())
        : null;

      if (productJSON) {
        const product = productJSON.product;
        const currentVariant = productJSON.selected_or_first_available_variant;

        if (product && product.options && currentVariant) {
          // Find fabric and color option indexes
          let fabricOptionIndex = -1;
          let colorOptionIndex = -1;

          product.options.forEach((option, index) => {
            const optionName = option.name.toLowerCase();
            if (optionName === "fabric" || optionName === "print") {
              fabricOptionIndex = index;
            } else if (optionName === "color") {
              colorOptionIndex = index;
            }
          });

          // Get values from current variant
          if (fabricOptionIndex >= 0) {
            currentFabric = currentVariant["option" + (fabricOptionIndex + 1)];
          }

          if (colorOptionIndex >= 0) {
            currentColor = currentVariant["option" + (colorOptionIndex + 1)];
          }
        }
      }
    }

    // If we still don't have fabric/color, try to get from match-color.js logs
    if (!currentFabric) {
      // Look for the fabric in the HTML
      const fabricText = $(".variant-type-fabric .active-variant")
        .text()
        .trim();
      if (fabricText) {
        currentFabric = fabricText;
      }
    }

    if (!currentColor) {
      // Look for the color in the HTML
      const colorText = $(".variant-type-color .active-variant").text().trim();
      if (colorText) {
        currentColor = colorText;
      }
    }

    // Now search for matching products
    let query = `q="${searchCode}"&view=colors`;

    if (!detail.inlucdeSaleProducts) {
      query = `q="${searchCode}" AND NOT ("Sale")&view=colors`;
    }

    $.getJSON(`/search?${query}`)
      .done(function (data) {
        if (!data) return;

        const { results } = data;
        if (!results || !results.length) {
          console.log("No matching products found");
          return;
        }

        // Add product title matching analysis
        const currentProductTitle = $(
          "h1.product__title, .product-single__title, .product__title",
        )
          .text()
          .trim();

        // Extract base title (remove size/fabric/color variants)
        const baseTitle = currentProductTitle
          .split(" - ")[0]
          .split(" | ")[0]
          .trim();

        // Count products that match by title
        let titleMatchCount = 0;
        let exactTitleMatches = [];
        let partialTitleMatches = [];

        results.forEach((prod, index) => {
          const prodTitle = prod.title || "";
          const prodBaseTitle = prodTitle
            .split(" - ")[0]
            .split(" | ")[0]
            .trim();

          // Check for exact title match
          if (prodBaseTitle.toLowerCase() === baseTitle.toLowerCase()) {
            titleMatchCount++;
            exactTitleMatches.push({
              index: index,
              title: prodTitle,
              handle: prod.handle,
              url: prod.url,
            });
          }
          // Check for partial title match (contains base title words)
          else if (baseTitle.length > 10) {
            // Only check partial matches for longer titles
            const baseWords = baseTitle
              .toLowerCase()
              .split(" ")
              .filter((word) => word.length > 3);
            const prodWords = prodBaseTitle
              .toLowerCase()
              .split(" ")
              .filter((word) => word.length > 3);

            let matchingWords = 0;
            baseWords.forEach((baseWord) => {
              if (
                prodWords.some(
                  (prodWord) =>
                    prodWord.includes(baseWord) || baseWord.includes(prodWord),
                )
              ) {
                matchingWords++;
              }
            });

            // If more than 60% of words match, consider it a partial match
            if (matchingWords / baseWords.length > 0.6) {
              partialTitleMatches.push({
                index: index,
                title: prodTitle,
                handle: prod.handle,
                url: prod.url,
                matchPercentage: Math.round(
                  (matchingWords / baseWords.length) * 100,
                ),
              });
            }
          }
        });

        if (exactTitleMatches.length > 0) {
          exactTitleMatches.forEach((match, i) => {
            console.log(`  ${i + 1}. "${match.title}" (${match.handle})`);
          });
        }

        if (partialTitleMatches.length > 0) {
          partialTitleMatches.forEach((match, i) => {
            console.log(
              `  ${i + 1}. "${match.title}" (${match.matchPercentage}% match) (${match.handle})`,
            );
          });
        }

        if (titleMatchCount === 0 && partialTitleMatches.length === 0) {
          console.log(
            "No title-based matches found - products may have different naming patterns",
          );
        }

        // First, try to find an exact match with both fabric and color
        let selectedProduct = null;

        // Extract the product handle to help with matching
        const currentProductHandle = window.location.pathname
          .split("/")
          .pop()
          .split("?")[0];
        // console.log('Current product handle:', currentProductHandle);

        if (currentFabric && currentColor) {
          // Try to find exact match with both fabric and color
          for (let i = 0; i < results.length; i++) {
            const prod = results[i];
            // console.log('Checking product for exact match:', prod.title, 'Handle:', prod.handle);
            //console.log('Product variants:', prod.variants);

            // Check if the product handle contains the color
            const normalizedColor = currentColor
              .toLowerCase()
              .replace(/\s+/g, "-");
            if (prod.handle.includes(normalizedColor)) {
              // Extract fabric from handle if possible
              const handleParts = prod.handle.split("-");
              // Check if the handle contains the fabric identifier
              const fabricMatch = handleParts.some((part) => {
                return (
                  currentFabric
                    .toLowerCase()
                    .replace(/\s+/g, "")
                    .includes(part) ||
                  part.includes(currentFabric.toLowerCase().replace(/\s+/g, ""))
                );
              });

              if (fabricMatch) {
                //console.log('Found exact match by handle with fabric and color:', prod.title);
                selectedProduct = prod;
                break;
              }
            }

            // OLD THEME APPROACH: Simple variant option matching (most reliable)
            if (prod.variants) {
              // Strategy 1: Exact variant option matching (like old theme)
              if (
                prod.variants.color === currentColor &&
                prod.variants.print === currentFabric
              ) {
                console.log(
                  "Found EXACT variant match (color + fabric):",
                  prod.title,
                );
                selectedProduct = prod;
                break;
              }
            }
          }
        }

        // Strategy 2: If no exact match, try fabric-only matching (old theme fallback)
        if (!selectedProduct) {
          for (let i = 0; i < results.length; i++) {
            const prod = results[i];

            if (prod.variants && prod.variants.print === currentFabric) {
              selectedProduct = prod;
              break;
            }
          }
        }

        // Strategy 3: Enhanced matching as fallback only
        if (!selectedProduct) {
          for (let i = 0; i < results.length; i++) {
            const prod = results[i];

            if (prod.variants) {
              // Convert to lowercase and normalize for comparison
              const prodFabric = (prod.variants.print || "")
                .toLowerCase()
                .replace(/\s+/g, "");
              const prodColor = (prod.variants.color || "")
                .toLowerCase()
                .replace(/\s+/g, "");
              const currFabric = currentFabric
                .toLowerCase()
                .replace(/\s+/g, "");
              const currColor = currentColor.toLowerCase().replace(/\s+/g, "");

              // Enhanced fabric matching - check if fabric matches
              let fabricMatch = false;
              if (
                prodFabric.includes(currFabric) ||
                currFabric.includes(prodFabric)
              ) {
                fabricMatch = true;
              } else {
                // Check if current fabric contains key terms that match the product fabric
                const currFabricWords = currFabric
                  .split(/[-\s(®)♻]+/)
                  .filter((word) => word.length > 3);
                const prodFabricWords = prodFabric
                  .split(/[-\s(®)♻]+/)
                  .filter((word) => word.length > 3);

                for (let currWord of currFabricWords) {
                  for (let prodWord of prodFabricWords) {
                    if (
                      currWord.includes(prodWord) ||
                      prodWord.includes(currWord)
                    ) {
                      fabricMatch = true;
                      console.log(
                        "Found fabric match by word:",
                        currWord,
                        "matches",
                        prodWord,
                      );
                      break;
                    }
                  }
                  if (fabricMatch) break;
                }
              }

              // Also check if the URL contains the fabric identifier
              if (
                !fabricMatch &&
                currentFabric.toLowerCase().includes("vita")
              ) {
                if (prod.url.toLowerCase().includes("vita")) {
                  fabricMatch = true;
                }
              }

              if (fabricMatch) {
                // Enhanced color matching with multiple strategies
                let colorMatch = false;

                // Strategy 1: Direct inclusion
                if (
                  prodColor.includes(currColor) ||
                  currColor.includes(prodColor)
                ) {
                  colorMatch = true;
                }

                // Strategy 2: Split color words and match individual words
                if (!colorMatch) {
                  const prodColorWords = prodColor
                    .split(/[-\s]+/)
                    .filter((word) => word.length > 2);
                  const currColorWords = currColor
                    .split(/[-\s]+/)
                    .filter((word) => word.length > 2);

                  for (let prodWord of prodColorWords) {
                    for (let currWord of currColorWords) {
                      if (
                        prodWord.includes(currWord) ||
                        currWord.includes(prodWord)
                      ) {
                        colorMatch = true;
                        console.log(
                          "Found color match by word:",
                          prodWord,
                          "matches",
                          currWord,
                        );
                        break;
                      }
                    }
                    if (colorMatch) break;
                  }
                }

                if (colorMatch) {
                  selectedProduct = prod;
                  break;
                }
              }
            }
          }
        }

        // If no exact match, try matching just the color
        if (!selectedProduct && currentColor) {
          for (let i = 0; i < results.length; i++) {
            const prod = results[i];

            if (prod.variants && prod.variants.color) {
              const prodColor = prod.variants.color
                .toLowerCase()
                .replace(/\s+/g, "");
              const currColor = currentColor.toLowerCase().replace(/\s+/g, "");

              // Enhanced color matching with multiple strategies
              let colorMatch = false;

              // Strategy 1: Direct inclusion
              if (
                prodColor.includes(currColor) ||
                currColor.includes(prodColor)
              ) {
                colorMatch = true;
              }

              // Strategy 2: Split color words and match individual words
              if (!colorMatch) {
                const prodColorWords = prodColor
                  .split(/[-\s]+/)
                  .filter((word) => word.length > 2);
                const currColorWords = currColor
                  .split(/[-\s]+/)
                  .filter((word) => word.length > 2);

                for (let prodWord of prodColorWords) {
                  for (let currWord of currColorWords) {
                    if (
                      prodWord.includes(currWord) ||
                      currWord.includes(prodWord)
                    ) {
                      colorMatch = true;
                      console.log(
                        "Found color match by word (color-only):",
                        prodWord,
                        "matches",
                        currWord,
                      );
                      break;
                    }
                  }
                  if (colorMatch) break;
                }
              }

              if (colorMatch) {
                selectedProduct = prod;
                break;
              }
            }
          }
        }

        // If no match found, prioritize title matches before using first result
        if (!selectedProduct && results.length > 0) {
          // Strategy 4: Prioritize exact title matches
          if (exactTitleMatches.length > 0) {
            selectedProduct = results[exactTitleMatches[0].index];
          }
          // Strategy 5: Use best partial title match
          else if (partialTitleMatches.length > 0) {
            // Sort by match percentage and pick the best one
            partialTitleMatches.sort(
              (a, b) => b.matchPercentage - a.matchPercentage,
            );
            selectedProduct = results[partialTitleMatches[0].index];
          }
          // Strategy 6: Fall back to first result
          else {
            selectedProduct = results[0];
            console.log(
              "No exact match found, using first result:",
              selectedProduct.title,
            );
          }
        }

        if (selectedProduct) {
          // OLD THEME APPROACH: Use the URL from search results (minimal processing)
          let productUrl = selectedProduct.url;

          // Only remove query parameters (like old theme did)
          if (productUrl.includes("?")) {
            productUrl = productUrl.split("?")[0];
            console.log("Cleaned URL (removed query params):", productUrl);
          }

          // Add matching product link to the product page
          relatedProdMain.addClass("__has-matching-content");
          relatedProdMain
            .find(".__match-top-bottom")
            .html(`<a href="${productUrl}">${buttonTitle}</a>`);

          if (relatedProdBottom.length) {
            relatedProdBottom.html(
              `<a class="hyperlink-underline" href="${productUrl}">${buttonTitleBottom}</a>`,
            );
            $("#button_after-add-to-bag-1").removeClass("full-width-button");
          }
        } else {
          console.log("No matching product found to display");
        }
      })
      .fail(function (error) {
        console.error("Error fetching related product:", error);
      });
  },

  getProdDetail: function () {
    match.getData(function (product) {
      // Ensure tags is properly handled whether it's a string or array
      let tags = [];
      if (product.tags) {
        if (Array.isArray(product.tags)) {
          tags = product.tags.join(",").toLowerCase();
        } else if (typeof product.tags === "string") {
          tags = product.tags.toLowerCase();
        }
      }

      if (tags && tags.includes("matching-")) {
        console.log("Found matching tag, processing...");
        match.matchingCase(product);
      }
    });
  },

  matchingCase: function (prod) {
    // Ensure tags is properly handled whether it's a string or array
    let tagsString = "";
    if (prod.tags) {
      if (Array.isArray(prod.tags)) {
        tagsString = prod.tags.join(",").toLowerCase();
      } else if (typeof prod.tags === "string") {
        tagsString = prod.tags.toLowerCase();
      }
    }

    const tagsArray = tagsString.split(",");
    const getMatchingTag = tagsArray.filter(function (item) {
      return item.includes("matching");
    });

    if (getMatchingTag.length) {
      match.getMatchingMomKids(getMatchingTag[0], prod);
    }
  },

  getMatchingMomKids: function (tag, prodDetail) {
    const cleanTags = tag.replace(" ", "");
    let searchForCode = cleanTags.split("-");
    searchForCode.shift();
    searchForCode = searchForCode.join("-");

    const getProductColorOption = prodDetail.options.find(function (item) {
      return item.name.toLowerCase() === "color";
    });

    if (!getProductColorOption) {
      console.error("No color option found for product");
      return;
    }

    const getSearchMatch = `/search?q=tag:"${searchForCode}",${getProductColorOption.values[0]}&view=colors`;

    match.get(getSearchMatch).done(function (item) {
      const res = item.results;
      const checker = {
        bsgs: {
          text: "Girls' Swim",
        },
        bsws: {
          text: "Women's Swim",
        },
      };

      if (res && res.length) {
        const getSimilarProdVariant = res.find(function (item) {
          const test = item.tags.filter(function (item) {
            return item.toLowerCase() === searchForCode;
          });
          if (test && test.length > 0) {
            return item.variants.color === getProductColorOption.values[0];
          }
        });

        if (getSimilarProdVariant) {
          const getMatchCode = tag.split("-")[1];
          const relatedContainer = $(".__button-related-prod");

          if (relatedContainer.length) {
            $(relatedContainer)
              .addClass("__has-matching-content")
              .append(
                $(
                  `<div class="match-container"><a href="${getSimilarProdVariant.url}">View Matching ${checker[getMatchCode].text}</a></div>`,
                ),
              );
          }
        }
      }
    });
  },

  get: function (url) {
    return $.getJSON(url);
  },
};

// Use jQuery document ready
$(document).ready(function () {
  match.init();
  match.getProdDetail();
  match.getMatchingCustomRushGuard();
  match.initMatchingProducts();
});
